const Save = (props) => {
	return <div>Edit Password</div>;
};

export default Save;
